<template>
  <div>
    <div class="flex">
      <router-link
        to="/add-weekly-tasks"
        tag="button"
        class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
      >Shto detyre te re</router-link>
      <router-link
        to="/excel"
        tag="button"
        class="ml-4 block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
      >Kthehu</router-link>
    </div>
    <WeeklyTasksTable />
  </div>
</template>

<script>
import WeeklyTasksTable from "./WeeklyTasksTable";

export default {
  components: {
    WeeklyTasksTable
  }
};
</script>

<style></style>
